/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardTeamsRouteImport } from './routes/_dashboard/teams'
import { Route as DashboardStudentsRouteImport } from './routes/_dashboard/students'
import { Route as DashboardQuestionsRouteImport } from './routes/_dashboard/questions'
import { Route as DashboardExamsRouteImport } from './routes/_dashboard/exams'
import { Route as DashboardDashboardRouteImport } from './routes/_dashboard/dashboard'
import { Route as DashboardCoursesRouteImport } from './routes/_dashboard/courses'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as DashboardTeamsIndexRouteImport } from './routes/_dashboard/teams/index'
import { Route as DashboardStudentsIndexRouteImport } from './routes/_dashboard/students/index'
import { Route as DashboardQuestionsIndexRouteImport } from './routes/_dashboard/questions/index'
import { Route as DashboardExamsIndexRouteImport } from './routes/_dashboard/exams/index'
import { Route as DashboardCoursesIndexRouteImport } from './routes/_dashboard/courses/index'
import { Route as DashboardTeamsTeamIdRouteImport } from './routes/_dashboard/teams/$teamId'
import { Route as DashboardStudentsStudentIdRouteImport } from './routes/_dashboard/students/$studentId'
import { Route as DashboardQuestionsQuestionIdRouteImport } from './routes/_dashboard/questions/$questionId'
import { Route as DashboardExamsExamIdRouteImport } from './routes/_dashboard/exams/$examId'
import { Route as DashboardCoursesCourseIdRouteImport } from './routes/_dashboard/courses/$courseId'

const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardTeamsRoute = DashboardTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardStudentsRoute = DashboardStudentsRouteImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardQuestionsRoute = DashboardQuestionsRouteImport.update({
  id: '/questions',
  path: '/questions',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardExamsRoute = DashboardExamsRouteImport.update({
  id: '/exams',
  path: '/exams',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDashboardRoute = DashboardDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCoursesRoute = DashboardCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => DashboardRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const DashboardTeamsIndexRoute = DashboardTeamsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardTeamsRoute,
} as any)
const DashboardStudentsIndexRoute = DashboardStudentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardStudentsRoute,
} as any)
const DashboardQuestionsIndexRoute = DashboardQuestionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardQuestionsRoute,
} as any)
const DashboardExamsIndexRoute = DashboardExamsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardExamsRoute,
} as any)
const DashboardCoursesIndexRoute = DashboardCoursesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardCoursesRoute,
} as any)
const DashboardTeamsTeamIdRoute = DashboardTeamsTeamIdRouteImport.update({
  id: '/$teamId',
  path: '/$teamId',
  getParentRoute: () => DashboardTeamsRoute,
} as any)
const DashboardStudentsStudentIdRoute =
  DashboardStudentsStudentIdRouteImport.update({
    id: '/$studentId',
    path: '/$studentId',
    getParentRoute: () => DashboardStudentsRoute,
  } as any)
const DashboardQuestionsQuestionIdRoute =
  DashboardQuestionsQuestionIdRouteImport.update({
    id: '/$questionId',
    path: '/$questionId',
    getParentRoute: () => DashboardQuestionsRoute,
  } as any)
const DashboardExamsExamIdRoute = DashboardExamsExamIdRouteImport.update({
  id: '/$examId',
  path: '/$examId',
  getParentRoute: () => DashboardExamsRoute,
} as any)
const DashboardCoursesCourseIdRoute =
  DashboardCoursesCourseIdRouteImport.update({
    id: '/$courseId',
    path: '/$courseId',
    getParentRoute: () => DashboardCoursesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/register': typeof AuthRegisterRoute
  '/sign-in': typeof AuthSignInRoute
  '/courses': typeof DashboardCoursesRouteWithChildren
  '/dashboard': typeof DashboardDashboardRoute
  '/exams': typeof DashboardExamsRouteWithChildren
  '/questions': typeof DashboardQuestionsRouteWithChildren
  '/students': typeof DashboardStudentsRouteWithChildren
  '/teams': typeof DashboardTeamsRouteWithChildren
  '/courses/$courseId': typeof DashboardCoursesCourseIdRoute
  '/exams/$examId': typeof DashboardExamsExamIdRoute
  '/questions/$questionId': typeof DashboardQuestionsQuestionIdRoute
  '/students/$studentId': typeof DashboardStudentsStudentIdRoute
  '/teams/$teamId': typeof DashboardTeamsTeamIdRoute
  '/courses/': typeof DashboardCoursesIndexRoute
  '/exams/': typeof DashboardExamsIndexRoute
  '/questions/': typeof DashboardQuestionsIndexRoute
  '/students/': typeof DashboardStudentsIndexRoute
  '/teams/': typeof DashboardTeamsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/register': typeof AuthRegisterRoute
  '/sign-in': typeof AuthSignInRoute
  '/dashboard': typeof DashboardDashboardRoute
  '/courses/$courseId': typeof DashboardCoursesCourseIdRoute
  '/exams/$examId': typeof DashboardExamsExamIdRoute
  '/questions/$questionId': typeof DashboardQuestionsQuestionIdRoute
  '/students/$studentId': typeof DashboardStudentsStudentIdRoute
  '/teams/$teamId': typeof DashboardTeamsTeamIdRoute
  '/courses': typeof DashboardCoursesIndexRoute
  '/exams': typeof DashboardExamsIndexRoute
  '/questions': typeof DashboardQuestionsIndexRoute
  '/students': typeof DashboardStudentsIndexRoute
  '/teams': typeof DashboardTeamsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_dashboard/courses': typeof DashboardCoursesRouteWithChildren
  '/_dashboard/dashboard': typeof DashboardDashboardRoute
  '/_dashboard/exams': typeof DashboardExamsRouteWithChildren
  '/_dashboard/questions': typeof DashboardQuestionsRouteWithChildren
  '/_dashboard/students': typeof DashboardStudentsRouteWithChildren
  '/_dashboard/teams': typeof DashboardTeamsRouteWithChildren
  '/_dashboard/courses/$courseId': typeof DashboardCoursesCourseIdRoute
  '/_dashboard/exams/$examId': typeof DashboardExamsExamIdRoute
  '/_dashboard/questions/$questionId': typeof DashboardQuestionsQuestionIdRoute
  '/_dashboard/students/$studentId': typeof DashboardStudentsStudentIdRoute
  '/_dashboard/teams/$teamId': typeof DashboardTeamsTeamIdRoute
  '/_dashboard/courses/': typeof DashboardCoursesIndexRoute
  '/_dashboard/exams/': typeof DashboardExamsIndexRoute
  '/_dashboard/questions/': typeof DashboardQuestionsIndexRoute
  '/_dashboard/students/': typeof DashboardStudentsIndexRoute
  '/_dashboard/teams/': typeof DashboardTeamsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/register'
    | '/sign-in'
    | '/courses'
    | '/dashboard'
    | '/exams'
    | '/questions'
    | '/students'
    | '/teams'
    | '/courses/$courseId'
    | '/exams/$examId'
    | '/questions/$questionId'
    | '/students/$studentId'
    | '/teams/$teamId'
    | '/courses/'
    | '/exams/'
    | '/questions/'
    | '/students/'
    | '/teams/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/register'
    | '/sign-in'
    | '/dashboard'
    | '/courses/$courseId'
    | '/exams/$examId'
    | '/questions/$questionId'
    | '/students/$studentId'
    | '/teams/$teamId'
    | '/courses'
    | '/exams'
    | '/questions'
    | '/students'
    | '/teams'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_dashboard'
    | '/_auth/register'
    | '/_auth/sign-in'
    | '/_dashboard/courses'
    | '/_dashboard/dashboard'
    | '/_dashboard/exams'
    | '/_dashboard/questions'
    | '/_dashboard/students'
    | '/_dashboard/teams'
    | '/_dashboard/courses/$courseId'
    | '/_dashboard/exams/$examId'
    | '/_dashboard/questions/$questionId'
    | '/_dashboard/students/$studentId'
    | '/_dashboard/teams/$teamId'
    | '/_dashboard/courses/'
    | '/_dashboard/exams/'
    | '/_dashboard/questions/'
    | '/_dashboard/students/'
    | '/_dashboard/teams/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/teams': {
      id: '/_dashboard/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof DashboardTeamsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/students': {
      id: '/_dashboard/students'
      path: '/students'
      fullPath: '/students'
      preLoaderRoute: typeof DashboardStudentsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/questions': {
      id: '/_dashboard/questions'
      path: '/questions'
      fullPath: '/questions'
      preLoaderRoute: typeof DashboardQuestionsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/exams': {
      id: '/_dashboard/exams'
      path: '/exams'
      fullPath: '/exams'
      preLoaderRoute: typeof DashboardExamsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard': {
      id: '/_dashboard/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardDashboardRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/courses': {
      id: '/_dashboard/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof DashboardCoursesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_dashboard/teams/': {
      id: '/_dashboard/teams/'
      path: '/'
      fullPath: '/teams/'
      preLoaderRoute: typeof DashboardTeamsIndexRouteImport
      parentRoute: typeof DashboardTeamsRoute
    }
    '/_dashboard/students/': {
      id: '/_dashboard/students/'
      path: '/'
      fullPath: '/students/'
      preLoaderRoute: typeof DashboardStudentsIndexRouteImport
      parentRoute: typeof DashboardStudentsRoute
    }
    '/_dashboard/questions/': {
      id: '/_dashboard/questions/'
      path: '/'
      fullPath: '/questions/'
      preLoaderRoute: typeof DashboardQuestionsIndexRouteImport
      parentRoute: typeof DashboardQuestionsRoute
    }
    '/_dashboard/exams/': {
      id: '/_dashboard/exams/'
      path: '/'
      fullPath: '/exams/'
      preLoaderRoute: typeof DashboardExamsIndexRouteImport
      parentRoute: typeof DashboardExamsRoute
    }
    '/_dashboard/courses/': {
      id: '/_dashboard/courses/'
      path: '/'
      fullPath: '/courses/'
      preLoaderRoute: typeof DashboardCoursesIndexRouteImport
      parentRoute: typeof DashboardCoursesRoute
    }
    '/_dashboard/teams/$teamId': {
      id: '/_dashboard/teams/$teamId'
      path: '/$teamId'
      fullPath: '/teams/$teamId'
      preLoaderRoute: typeof DashboardTeamsTeamIdRouteImport
      parentRoute: typeof DashboardTeamsRoute
    }
    '/_dashboard/students/$studentId': {
      id: '/_dashboard/students/$studentId'
      path: '/$studentId'
      fullPath: '/students/$studentId'
      preLoaderRoute: typeof DashboardStudentsStudentIdRouteImport
      parentRoute: typeof DashboardStudentsRoute
    }
    '/_dashboard/questions/$questionId': {
      id: '/_dashboard/questions/$questionId'
      path: '/$questionId'
      fullPath: '/questions/$questionId'
      preLoaderRoute: typeof DashboardQuestionsQuestionIdRouteImport
      parentRoute: typeof DashboardQuestionsRoute
    }
    '/_dashboard/exams/$examId': {
      id: '/_dashboard/exams/$examId'
      path: '/$examId'
      fullPath: '/exams/$examId'
      preLoaderRoute: typeof DashboardExamsExamIdRouteImport
      parentRoute: typeof DashboardExamsRoute
    }
    '/_dashboard/courses/$courseId': {
      id: '/_dashboard/courses/$courseId'
      path: '/$courseId'
      fullPath: '/courses/$courseId'
      preLoaderRoute: typeof DashboardCoursesCourseIdRouteImport
      parentRoute: typeof DashboardCoursesRoute
    }
  }
}

interface AuthRouteChildren {
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthSignInRoute: typeof AuthSignInRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthRegisterRoute: AuthRegisterRoute,
  AuthSignInRoute: AuthSignInRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DashboardCoursesRouteChildren {
  DashboardCoursesCourseIdRoute: typeof DashboardCoursesCourseIdRoute
  DashboardCoursesIndexRoute: typeof DashboardCoursesIndexRoute
}

const DashboardCoursesRouteChildren: DashboardCoursesRouteChildren = {
  DashboardCoursesCourseIdRoute: DashboardCoursesCourseIdRoute,
  DashboardCoursesIndexRoute: DashboardCoursesIndexRoute,
}

const DashboardCoursesRouteWithChildren =
  DashboardCoursesRoute._addFileChildren(DashboardCoursesRouteChildren)

interface DashboardExamsRouteChildren {
  DashboardExamsExamIdRoute: typeof DashboardExamsExamIdRoute
  DashboardExamsIndexRoute: typeof DashboardExamsIndexRoute
}

const DashboardExamsRouteChildren: DashboardExamsRouteChildren = {
  DashboardExamsExamIdRoute: DashboardExamsExamIdRoute,
  DashboardExamsIndexRoute: DashboardExamsIndexRoute,
}

const DashboardExamsRouteWithChildren = DashboardExamsRoute._addFileChildren(
  DashboardExamsRouteChildren,
)

interface DashboardQuestionsRouteChildren {
  DashboardQuestionsQuestionIdRoute: typeof DashboardQuestionsQuestionIdRoute
  DashboardQuestionsIndexRoute: typeof DashboardQuestionsIndexRoute
}

const DashboardQuestionsRouteChildren: DashboardQuestionsRouteChildren = {
  DashboardQuestionsQuestionIdRoute: DashboardQuestionsQuestionIdRoute,
  DashboardQuestionsIndexRoute: DashboardQuestionsIndexRoute,
}

const DashboardQuestionsRouteWithChildren =
  DashboardQuestionsRoute._addFileChildren(DashboardQuestionsRouteChildren)

interface DashboardStudentsRouteChildren {
  DashboardStudentsStudentIdRoute: typeof DashboardStudentsStudentIdRoute
  DashboardStudentsIndexRoute: typeof DashboardStudentsIndexRoute
}

const DashboardStudentsRouteChildren: DashboardStudentsRouteChildren = {
  DashboardStudentsStudentIdRoute: DashboardStudentsStudentIdRoute,
  DashboardStudentsIndexRoute: DashboardStudentsIndexRoute,
}

const DashboardStudentsRouteWithChildren =
  DashboardStudentsRoute._addFileChildren(DashboardStudentsRouteChildren)

interface DashboardTeamsRouteChildren {
  DashboardTeamsTeamIdRoute: typeof DashboardTeamsTeamIdRoute
  DashboardTeamsIndexRoute: typeof DashboardTeamsIndexRoute
}

const DashboardTeamsRouteChildren: DashboardTeamsRouteChildren = {
  DashboardTeamsTeamIdRoute: DashboardTeamsTeamIdRoute,
  DashboardTeamsIndexRoute: DashboardTeamsIndexRoute,
}

const DashboardTeamsRouteWithChildren = DashboardTeamsRoute._addFileChildren(
  DashboardTeamsRouteChildren,
)

interface DashboardRouteChildren {
  DashboardCoursesRoute: typeof DashboardCoursesRouteWithChildren
  DashboardDashboardRoute: typeof DashboardDashboardRoute
  DashboardExamsRoute: typeof DashboardExamsRouteWithChildren
  DashboardQuestionsRoute: typeof DashboardQuestionsRouteWithChildren
  DashboardStudentsRoute: typeof DashboardStudentsRouteWithChildren
  DashboardTeamsRoute: typeof DashboardTeamsRouteWithChildren
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardCoursesRoute: DashboardCoursesRouteWithChildren,
  DashboardDashboardRoute: DashboardDashboardRoute,
  DashboardExamsRoute: DashboardExamsRouteWithChildren,
  DashboardQuestionsRoute: DashboardQuestionsRouteWithChildren,
  DashboardStudentsRoute: DashboardStudentsRouteWithChildren,
  DashboardTeamsRoute: DashboardTeamsRouteWithChildren,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
